import { defineStore } from "pinia";

import modelClass from "@models/notification";
import * as getters from "@modelStores/helpers/getters-helper";

export const useNotificationStore = defineStore("notification-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
